import React, { ComponentProps } from 'react';
import { GlobalDocumentIds } from '../../../types/GlobalDocumentIds';
import { Namespace } from '../../../translation/namespace';
import { asView } from '../../../_lib/ViewFetcher';
import { BreadcrumbListItem, BreadcrumbItemProps } from '../partials/BreadcrumbListItem';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type BreadcrumbProps = {
  items?: Omit<BreadcrumbItemProps, 'index'>[];
};

function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useSonTranslation(Namespace.Breadcrumb);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    // we add a (redundant) role "navigation" for better screen reader support
    <nav
      className="breadcrumb"
      id={GlobalDocumentIds.breadcrumb}
      aria-label={t('breadcrumblabelDescription')}
    >
      <ol className="breadcrumb__list">
        {items?.map((item, index) => (
          <BreadcrumbListItem
            key={`${item.navItem?.link?.url}${item.navItem?.link?.name}`}
            navItem={item.navItem}
            siblings={item.siblings}
            hasReadRestrictions={item.hasReadRestrictions}
            index={index}
          />
        ))}
      </ol>
    </nav>
  );
}

export const BreadcrumbDefaultView = asView(Breadcrumb);
export type BreadcrumbDefaultViewProps = ComponentProps<typeof BreadcrumbDefaultView>;
